/**
 * withCurrencies
 * HOC for wrapping the provided component with CurrenciesProvider
 */

import React from 'react'

import CurrenciesProvider from './currencies-provider'

export default function withCurrencies (WrappedComponent) {
  return function CurrenciesProviderHOC(props) {
    return (
      <CurrenciesProvider>
        <WrappedComponent {...props} />
      </CurrenciesProvider>
    )
  }
}
